import type { ReactNode } from 'react';
import { UserRole } from '@sphere/auth/domain';

export type DocsSection = 'start' | 'workflows' | 'modules' | 'glossary';

export interface DocsArticle {
  slug: string;
  title: string;
  summary: string;
  roles: UserRole[];
  section: DocsSection;
  tags: string[];
  body: ReactNode;
}

export interface RoleDocsMeta {
  title: string;
  intro: string;
}

export const DOCS_SECTION_LABELS: Record<DocsSection, string> = {
  start: 'Démarrer',
  workflows: 'Parcours',
  modules: 'Modules',
  glossary: 'Glossaire',
};

export const DOCS_SECTION_ORDER: DocsSection[] = [
  'start',
  'workflows',
  'modules',
  'glossary',
];
